export const customChipColors = {
  greyBlue: {
    backgroundColor: '#F8F9FC',
    borderColor: '#D5D9EB',
    color: '#363F72',
    iconColor: '#4E5BA6',
  },
  lightBlue: {
    backgroundColor: '#F0F9FF',
    borderColor: '#B9E6FE',
    color: '#026AA2',
    iconColor: '#0BA5EC',
  },
  blue: {
    backgroundColor: '#EFF8FF',
    borderColor: '#B2DDFF',
    color: '#175CD3',
    iconColor: '#2E90FA',
  },
  indigo: {
    backgroundColor: '#EEF4FF',
    borderColor: '#C7D7FE',
    color: '#3538CD',
    iconColor: '#6172F3',
  },
  purple: {
    backgroundColor: '#F4F3FF',
    borderColor: '#D9D6FE',
    color: '#5925DC',
    iconColor: '#7A5AF8',
  },
  pink: {
    backgroundColor: '#FDF2FA',
    borderColor: '#FCCEEE',
    color: '#C11574',
    iconColor: '#EE46BC',
  },
  orange: {
    backgroundColor: '#FEF6EE',
    borderColor: '#F9DBAF',
    color: '#B93815',
    iconColor: '#EF6820',
  },
} as const;

export type CustomChipColors = keyof typeof customChipColors;

export const customChipColorsKeys = Object.keys(customChipColors);
